module.exports =
  # Keyboard (ie e.which) values
  LEFT     : 37
  RIGHT    : 39
  SPACEBAR : 32
  UP       : 38
  DOWN     : 40
  A        : 65
  D        : 68
  W        : 87
